module.exports = __webpack_public_path__ + "assets/img/beak.6eb04c61.svg";